///// HEADER //////


///// OPEN MENU ON HOVER //////
let items = document.querySelector(".header__inline-menu").querySelectorAll("details");
  console.log(items)
  items.forEach(item => {
    item.addEventListener("mouseover", () => {
      item.setAttribute("open", true);
      item.querySelector("ul").addEventListener("mouseleave", () => {
        item.removeAttribute("open");
      });
    item.addEventListener("mouseleave", () => {
      item.removeAttribute("open");
    });
  });
  
  });

///// MNU ON HOVER END /////

function myFunction() {
  var input = document.getElementById("Search");
  var filter = input.value.toLowerCase();
  var nodes = document.getElementsByClassName('likovi');

  for (i = 0; i < nodes.length; i++) {
    if (nodes[i].innerText.toLowerCase().includes(filter)) {
      nodes[i].style.display = "block";
    } else {
      nodes[i].style.display = "none";
    }
  }
}

///// HEADER END /////

$(document).ready(function() {
  $('#Manuals a').click(function(event) {
    event.preventDefault(); // Prevents the default action of the link

    var url = $(this).attr('href'); // Get the URL of the link
    window.open(url, '_blank'); // Open the URL in a new tab/window
  });
});

//// PRODUCT PAGE ////

$(".der a").click( function(){
    $("#tabovi button:first-of-type").addClass("active")
    $("#Description").css("display", "block")
})

if (document.querySelector('.mobtab')) {
  document.querySelector('.mobtab').addEventListener('click', function(e) {
      if(e.target.tagName === 'BUTTON') {
          // Get all elements with the same class as the clicked button
          var elements = document.querySelectorAll('.' + e.target.className);
  
          elements.forEach(function(element) {
              // Perform a click action or any other action you want
              // Avoiding click on the original button that was clicked
              if(element !== e.target) {
                  element.click();
              }
          });
      }
  });
}


//// BOOST MY FIX ////

    function showSearchElements() {
        // Display the search suggestion elements
        document.querySelector('.boost-pfs-search-suggestion-mobile-overlay').style.display = 'block';
        document.querySelector('.boost-pfs-search-suggestion-mobile-top-panel').style.display = 'block';

        // Focus on the input element to bring up the keyboard on mobile devices
        document.getElementById('boost-pfs-search-box-mobile').focus();
    }

    // Adding click event listener to your SVG container
    document.querySelector('.search_icon_custom').addEventListener('click', showSearchElements);



